define(["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.WaEquipMaintInspFreqDomain = void 0;
    class WaEquipMaintInspFreqDomain {
        static initialise() {
            if (!this.isInitialised) {
                this.isInitialised = true;
                this.values = [
                    { key: WaEquipMaintInspFreqDomain.Annual, value: "Annual" },
                    { key: WaEquipMaintInspFreqDomain.SixMonthly, value: "Six monthly" },
                    { key: WaEquipMaintInspFreqDomain.Quarterly, value: "Quarterly" },
                    { key: WaEquipMaintInspFreqDomain.Regular, value: "Regular" }
                ];
                this.KeyIndex = {};
                this.KeyIndex[WaEquipMaintInspFreqDomain.Annual] = 0;
                this.KeyIndex[WaEquipMaintInspFreqDomain.SixMonthly] = 1;
                this.KeyIndex[WaEquipMaintInspFreqDomain.Quarterly] = 2;
                this.KeyIndex[WaEquipMaintInspFreqDomain.Regular] = 3;
                this.ValueIndex = {};
                this.ValueIndex["Annual"] = 0;
                this.ValueIndex["Six monthly"] = 1;
                this.ValueIndex["Quarterly"] = 2;
                this.ValueIndex["Regular"] = 3;
            }
        }
        static get Values() {
            this.initialise();
            return this.values;
        }
        static findByValue(value) {
            this.initialise();
            if (this.ValueIndex[value] != null) {
                return this.Values[this.ValueIndex[value]];
            }
            return null;
        }
        static findByKey(key) {
            this.initialise();
            if (this.KeyIndex[key] != null) {
                return this.Values[this.KeyIndex[key]];
            }
            return null;
        }
    }
    exports.WaEquipMaintInspFreqDomain = WaEquipMaintInspFreqDomain;
    Object.defineProperty(WaEquipMaintInspFreqDomain, "Annual", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 0
    });
    Object.defineProperty(WaEquipMaintInspFreqDomain, "SixMonthly", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 1
    });
    Object.defineProperty(WaEquipMaintInspFreqDomain, "Quarterly", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 2
    });
    Object.defineProperty(WaEquipMaintInspFreqDomain, "Regular", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 3
    });
    Object.defineProperty(WaEquipMaintInspFreqDomain, "isInitialised", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
});
